import { ReactNode } from 'react'

import { AuthProvider } from 'contexts/AuthContext'
import { AutoSyncProvider } from 'contexts/AutoSyncContext'
import { CVProcessingProvider } from 'contexts/CVProcessingContext'
import { EmailSendingProvider } from 'contexts/EmailSendingContext'
import { LanguageProvider } from 'contexts/LanguageContext'
import { NotificationProvider } from 'contexts/NotificationContext'
import { ThemeProvider } from 'contexts/ThemeContext'
import { ToastProvider } from 'contexts/ToastContext'

interface AppProvidersProps {
  children: ReactNode
}

export const AppProviders = ({ children }: AppProvidersProps) => (
  <AuthProvider>
    <LanguageProvider>
      <ThemeProvider>
        <NotificationProvider>
          <ToastProvider>
            <AutoSyncProvider>
              <CVProcessingProvider>
                <EmailSendingProvider>
                  {children}
                </EmailSendingProvider>
              </CVProcessingProvider>
            </AutoSyncProvider>
          </ToastProvider>
        </NotificationProvider>
      </ThemeProvider>
    </LanguageProvider>
  </AuthProvider>
)

